var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.selected,{tag:"component",attrs:{"id":"app"}},[_c('app-nav'),_c('main',[_c('app-item',{staticClass:"item",attrs:{"unit":_vm.tree}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }